import { render } from "./AboutFilmComponent.vue?vue&type=template&id=ec992dc0&scoped=true"
import script from "./AboutFilmComponent.vue?vue&type=script&lang=js"
export * from "./AboutFilmComponent.vue?vue&type=script&lang=js"

import "./AboutFilmComponent.vue?vue&type=style&index=0&id=ec992dc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec992dc0"]])

export default __exports__